<template>
  <div class="bill-table-list-worker" v-loading="isLoading">
    <el-row class="ui-align-right">
      <el-button
        type="warning"
        @click="getDataList(true, params, true)"
        :disabled="!dataList.length"
        >下载
      </el-button>
    </el-row>
    <el-table v-loading="isLoading" :data="dataList">
      <el-table-column v-show="tableHeaders.length" type="index" label="序号" width="50" />
      <el-table-column v-show="tableHeaders.length" label="账期">{{
        (params && params.month) || '-'
      }}</el-table-column>
      <el-table-column
        v-for="item in tableHeaders"
        :label="item"
        :prop="item"
        :key="item"
        min-width="160"
      />
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'

export default {
  mixins: [pagination],

  data() {
    return {
      dataList: [],
      tableHeaders: [],
      isLoading: false,
      params: null,
      pageSize: 10,
    }
  },

  created() {
    this.initPagination('getDataList', false)
  },

  methods: {
    // 列表数据
    getDataList(init = false, params = null, exportData = false) {
      if (init) this.pageNo = 1
      this.params = params || this.params
      this.params.pageSize = this.pageSize
      this.params.pageNumber = this.pageNo
      if (exportData) return this.exportDataList(this.params)
      this.isLoading = true
      this.fetch
        .get('srm_hrisStatisList', { params: this.params })
        .then(res => {
          this.isLoading = false
          const data = res.data || {}
          if (init) {
            Object.keys(data.headers).forEach(item => {
              this.tableHeaders = this.tableHeaders.concat(data.headers[item])
            })
          }
          this.totalAmount = data.total || 0
          this.$nextTick(() => {
            this.dataList = data.salaryFieldValues || []
          })
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    // 导出
    exportDataList(params) {
      this.isLoading = true
      this.fetch
        .get('hrisStatisExport', {
          params,
        })
        .then(res => {
          this.isLoading = false
          if (res.data) {
            window.downloadFile(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
